var _key_value_util = require('./_key_value_util');
var hash_util = require('./hash_util');

var _Search = hash_util._Hash;

module.exports = {
	initBySearchString: function (s) {
		if (!s) {
			s = '?';
		}
		if (s.indexOf('?') != 0) {
			console.log('不合法的 Search');
			return false;
		}
		var o = _key_value_util.string2Object(s.substr(1));
		return this.initBySearchObject(o);
	},
	initBySearchObject: function (o) {
		return new _Search(o, '?');
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/url_util/search_util.js
// module id = 247
// module chunks = 1